/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacthirelawyerdescription3Inputs */

const en_artifacthirelawyerdescription3 = /** @type {(inputs: Artifacthirelawyerdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We're partnering with vetted Portuguese construction-dispute lawyers who can take it from here. Coming soon.`)
};

const pt_artifacthirelawyerdescription3 = /** @type {(inputs: Artifacthirelawyerdescription3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estamos a fechar parcerias com advogados portugueses verificados em disputas de obras que podem assumir daqui. Em breve.`)
};

/**
* | output |
* | --- |
* | "We're partnering with vetted Portuguese construction-dispute lawyers who can take it from here. Coming soon." |
*
* @param {Artifacthirelawyerdescription3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifacthirelawyerdescription3 = /** @type {((inputs?: Artifacthirelawyerdescription3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacthirelawyerdescription3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifacthirelawyerdescription3(inputs)
	return pt_artifacthirelawyerdescription3(inputs)
});
export { artifacthirelawyerdescription3 as "artifactHireLawyerDescription" }